import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import scrollToElement from 'scroll-to-element'
import { Row, Col } from 'react-bootstrap'
import {
  RelatedSidebarContainer,
  MoreHelpFooterContainer,
  SocialMediaContainer
} from '../../containers'
import { Helmet } from 'react-helmet'
import styled, { css, withTheme } from 'styled-components'
import { useAppContext } from '../../containers/App/Context'

const v4 = css`
  .content-header {
    border-bottom: none;
    text-align: unset;
    font-weight: 700;
    color: var(--clr-black-to-text);
  }

  .sidebar {
    border-right: none;
  }
`

const Wrapper = styled.div`
  margin-top: 15px;

  .content-header {
    color: var(--clr-grey-4-to-text);
    text-align: center;
    border-bottom: 1px solid var(--clr-grey-6-to-text);
    margin-top: 0;
    padding-bottom: 5px;
    font-size: 2em;
  }

  .content-body {
    margin-top: 10px;
  }

  .row {
    width: 100%;
  }

  .overflow-row {
    overflow: hidden;
  }

  .content-bottom {
    margin: 40px 0px 0px 32px;

    @media (max-width: 767px) {
      margin: 40px 0px 0px 26px;
    }
  }

  .sidebar {
    height: 100%;
    border-right: 1px solid var(--clr-grey-6-to-text);
    vertical-align: top;
    margin-bottom: -9999px;
    padding-bottom: 9999px;
  }

  .child-panel {
    padding-right: 0;
  }

  ${props => props.version === 'v4' && v4}

  @media (max-width: 992px) {
    margin-top: 5px;

    .child-panel {
      margin-bottom: 30px;
      padding: 0;
    }

    .content-body {
      margin-top: 0px;
    }
  }
`

const proptypes = {
  noSideBar: PropTypes.bool,
  showMostSeenTutorials: PropTypes.bool,
  children: PropTypes.node,
  relatedData: PropTypes.array,
  relatedType: PropTypes.string,
  isFetching: PropTypes.bool,
  title: PropTypes.string,
  contentType: PropTypes.string.isRequired,
  tutorials: PropTypes.array,
  relatedId: PropTypes.number,
  sidebarContent: PropTypes.element
}

const TrialLayout = props => {
  const {
    noSideBar,
    title = '',
    contentType,
    relatedId,
    children,
    relatedType,
    sidebarContent
  } = props

  useEffect(() => {
    scrollToElement('.content-top', { duration: 200 })
  }, [window.location])

  const { versionKey: version } = useAppContext()

  return (
    <Row>
      <Wrapper version={version}>
        <Helmet
          title={title}
          link={[<link rel="canonical" href={`${window.location.href}`} />]}
        />
        <div className="content-body animated fadeIn" itemScope>
          <SocialMediaContainer
            contentType={contentType}
            contentId={relatedId}
            contentTitle={props.title}
            version={version}
          />
          <div className="row overflow-row">
            <Col
              md={noSideBar ? 12 : 9}
              mdPush={noSideBar ? 0 : 3}
              className="child-panel"
            >
              <Row>
                <Col md={12} className="col">
                  <div className="content-top" />
                  <h1 className="content-header">{title}</h1>
                  {children}
                </Col>
              </Row>
            </Col>
            <If condition={!noSideBar}>
              <Col md={3} mdPull={9} className="sidebar">
                <If condition={!sidebarContent}>
                  <RelatedSidebarContainer
                    relatedType={relatedType}
                    id={relatedId}
                    contentType={contentType}
                  />
                </If>
                {sidebarContent}
              </Col>
            </If>
          </div>
          <If condition={sidebarContent}>
            <div className="content-bottom">
              <Row>
                <RelatedSidebarContainer
                  relatedType={relatedType}
                  id={relatedId}
                  contentType={contentType}
                />
              </Row>
            </div>
          </If>
          <MoreHelpFooterContainer />
        </div>
      </Wrapper>
    </Row>
  )
}

TrialLayout.propTypes = proptypes

export default withTheme(TrialLayout)



// WEBPACK FOOTER //
// ./src/components/TrialLayout/TrialLayout.js